export const TransactionDistribution = {
  UNIQUE_SOLUTION: 'unique_solution',
  RENT: 'rent',
  DEPRECATION: 'depreciation',
};
